export default "__VITE_ASSET__Bh_47MwK__"